import {
    deleteFavouriteViaAPI,
    putFavouriteViaAPI
} from '../pages/Search/methods';

const userActions = {
    toggleFavourite: (userId, assetId, favouriteActive) => {
        return dispatch => {
            dispatch(userActions.startToggleFavouriteRequest());
            const apiRequest = favouriteActive ? deleteFavouriteViaAPI : putFavouriteViaAPI;
            return apiRequest(userId, assetId)
                .then(() => {
                    dispatch(userActions.toggleFavouriteSuccess(assetId));
                })
                .catch(error => {
                    dispatch(userActions.toggleFavouriteFailure(error));
                });
        };
    },
    startToggleFavouriteRequest: () => ({
        type: 'START_TOGGLE_FAVOURITE_REQUEST'
    }),
    toggleFavouriteSuccess: assetId => ({
        type: 'TOGGLE_FAVOURITE_SUCCESS',
        payload: {
            assetId
        }
    }),
    toggleFavouriteFailure: error => ({
        type: 'TOGGLE_FAVOURITE_FAILURE',
        payload: {
            error
        }
    })
};

export default userActions;



// WEBPACK FOOTER //
// ./src/actions/userActions.js